import React from 'react';
import { auth } from '../firebase';
import { Form, FormGroup, Button, Input } from '../styles/components';
const INITIAL_STATE = {
  passwordOne: '',
  passwordTwo: '',
  error: null
};

class PasswordChangeForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }
  onSubmit(event) {
    event.preventDefault();
    const { passwordOne } = this.state;
    auth.currentUser
      .updatePassword(passwordOne)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
      })
      .catch(error => this.setState({ error }));
  }
  render() {
    const { passwordOne, passwordTwo, error } = this.state;
    const { layoutItem: LayoutItem } = this.props;
    const isInvalid = passwordOne === passwordTwo && passwordOne.length;
    return (
      <LayoutItem>
        <Form onSubmit={this.onSubmit.bind(this)}>
          <FormGroup>
            <Input
              type="password"
              value={passwordOne}
              onChange={event =>
                this.setState({ passwordOne: event.target.value })
              }
              placeholder="new password"
            />
          </FormGroup>
          <FormGroup>
            <Input
              type="password"
              value={passwordTwo}
              onChange={event =>
                this.setState({ passwordTwo: event.target.value })
              }
              placeholder="confirm password"
            />
          </FormGroup>
          <FormGroup>
            <Button disabled={isInvalid} type="submit">
              Reset password
            </Button>
          </FormGroup>
        </Form>
      </LayoutItem>
    );
  }
}

export default PasswordChangeForm;
